module.exports = __webpack_public_path__ + "static/media/filter.5f094e0f.svg";